/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ credits: NonNullable<unknown> }} Property_Registry_Lv_DownloadInputs */

const cs_property_registry_lv_download = /** @type {(inputs: Property_Registry_Lv_DownloadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Stáhnout výpis LV (${i?.credits} kr.)`)
};

const en_property_registry_lv_download = /** @type {(inputs: Property_Registry_Lv_DownloadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Download LV extract (${i?.credits} cr.)`)
};

/**
* | output |
* | --- |
* | "Download LV extract ({credits} cr.)" |
*
* @param {Property_Registry_Lv_DownloadInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_registry_lv_download = /** @type {((inputs: Property_Registry_Lv_DownloadInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Registry_Lv_DownloadInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_registry_lv_download(inputs)
	return cs_property_registry_lv_download(inputs)
});